import AuthCurrentTenant from 'src/modules/auth/authCurrentTenant';
import authAxios from 'src/modules/shared/axios/authAxios';

export default class PlanificacionService {
  static async update(id, data) {
    const body = {
      id,
      data,
    };

    const tenantId = AuthCurrentTenant.get();

    const response = await authAxios.put(`/tenant/${tenantId}/planificacion/${id}`, body);

    return response.data;
  }

  static async destroyAll(ids) {
    const params = {
      ids,
    };

    const tenantId = AuthCurrentTenant.get();

    const response = await authAxios.delete(`/tenant/${tenantId}/planificacion`, {
      params,
    });

    return response.data;
  }

  static async createFromTemplates(data) {
    const body = {
      data,
    };

    const tenantId = AuthCurrentTenant.get();

    const response = await authAxios.post(`/tenant/${tenantId}/planificacion-from-templates`, body);

    return response.data;
  }

  static async create(data) {
    const body = {
      data,
    };

    const tenantId = AuthCurrentTenant.get();

    const response = await authAxios.post(`/tenant/${tenantId}/planificacion`, body);

    return response.data;
  }

  static async import(values, importHash) {
    const body = {
      data: values,
      importHash,
    };

    const tenantId = AuthCurrentTenant.get();

    const response = await authAxios.post(`/tenant/${tenantId}/planificacion/import`, body);

    return response.data;
  }

  static async find(id) {
    const tenantId = AuthCurrentTenant.get();

    const response = await authAxios.get(`/tenant/${tenantId}/planificacion/${id}`);

    return response.data;
  }

  static async listTree(filter, orderBy) {
    const body = {
      filter,
      orderBy,
    };
    const tenantId = AuthCurrentTenant.get();
    const url = tenantId ? `/tenant/${tenantId}/planificacion/list-tree` : '/planificacion/list-tree';
    const response = await authAxios.post(url, body);
    return response.data;
  }

  static async list(filter, orderBy, limit, offset) {
    const params = {
      filter,
      orderBy,
      limit,
      offset,
    };

    const tenantId = AuthCurrentTenant.get();

    const response = await authAxios.get(`/tenant/${tenantId}/planificacion`, {
      params,
    });

    return response.data;
  }
  
  static async listTareas(filter) {
    const params = { filter };
    const tenantId = AuthCurrentTenant.get();
    
    const response = await authAxios.get(`/tenant/${tenantId}/planificacion/${filter.planificacion}/tareas`, {
      params,
    });
    
    return response.data;
  }

  static async listAutocomplete(query, limit) {
    const params = {
      query,
      limit,
    };

    const tenantId = AuthCurrentTenant.get();

    const response = await authAxios.get(`/tenant/${tenantId}/planificacion/autocomplete`, {
      params,
    });

    return response.data;
  }
}
